<ng-container *transloco="let t; read:'permit.countersign'">
    <div class="modal" [class.modal--no-scroll]="noScroll">
        <div class="modal__content">
            <div class="add-countersign">
                <div class="add-countersign__header">
                    <div class="add-countersign__header__heading">{{t('title')}}</div>
                </div>
                 <form [formGroup]="form" [ngxsFormDebounce]="0" ngxsForm="permitTeam.newPermitTeamTextMemberForm" class="create__form">
                    <ng-container>
                        <ha-input class="create__form__field" formControlName="member" [label]="t('name')" [readOnlyOnDisabled]="true"></ha-input>                         
                        <ha-select class="create__form__field" formControlName="role" [label]="t('role')" [options]="roles" [sortWhenTranslated]="true" [keepLastWhenSorted]="true">
                        </ha-select>

                        <ha-input *ngIf="form.get('role')?.value === CountersignRole.OtherRole"
                                tabindex="0"
                                class="create__form__field"
                                formControlName="roletext"
                                [label]="t('role')"
                                [readOnlyOnDisabled]="true">
                        </ha-input>

                        <signature-pad *ngIf="signaturePadOptions" class="modal__content__signature" #signature [options]="signaturePadOptions"
                                                (drawStart)="drawStart($event)" (drawEnd)="drawComplete($event)"></signature-pad>
                        <div class="modal__content__details">
                            <button class="modal__content__clear-button" (click)="clear()">{{ t("clear") }}</button>
                        </div>
                    </ng-container>
                </form>
            </div>
        </div>
         <div class="modal__actions">
            <button class="modal__actions__close" type="button" (click)="close()">{{ t("cancel") }}</button>
            <button class="modal__actions__save" [class.modal__actions__save--disabled]="!isValid" type="button" (click)="save()">{{ t('save') }}</button>
        </div>
    </div>
    <modal #alertModal class="alert-modal" [cancelLabel]="t('cancelAlert.cancel')" (cancel)="continue()" [okLabel]="t('cancelAlert.ok')" (ok)="abortClear()">
        <div [innerHtml]="t('cancelAlert.information')"></div>
    </modal>
</ng-container>